/**
 * pdf.js, nachgeladen — erst wenn jemand ein Dokument öffnet.
 *
 * Rund 1 MB Bibliothek plus Worker, die sonst jede Seite des Portals mitschleppen würde. Die
 * Legacy-Ausgabe, weil die Standardausgabe von 4.x `Promise.withResolvers` voraussetzt (Safari erst
 * ab 17.4).
 *
 * Reihenfolge zählt: `pdf_viewer.mjs` liest `globalThis.pdfjsLib` **beim Laden** aus, also wird die
 * Bibliothek vorher dort abgelegt.
 *
 * `isEvalSupported: false` ist Pflicht, nicht Vorsicht: Die Dokumente sind Ausschreibungsunterlagen
 * Dritter, und über die Schriftkompilierung ließ sich in pdf.js schon Code ausführen
 * (CVE-2024-4367, in 4.2.67 behoben — die Einstellung schließt die Klasse unabhängig davon).
 */
let runtime: Promise<{ pdfjs: any; viewer: any }> | null = null;

export const loadPdfRuntime = (): Promise<{ pdfjs: any; viewer: any }> => {
    if (!runtime) {
        runtime = (async () => {
            const pdfjs = await import('pdfjs-dist/legacy/build/pdf.mjs');
            (globalThis as any).pdfjsLib = pdfjs;
            pdfjs.GlobalWorkerOptions.workerPort = new Worker(
                new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url),
                { type: 'module' }
            );
            const viewer = await import('pdfjs-dist/legacy/web/pdf_viewer.mjs');
            return { pdfjs, viewer };
        })().catch(error => {
            runtime = null;
            throw error;
        });
    }
    return runtime;
};

/** Dokumentoptionen: nichts ausführen, nichts nachladen. */
export const SAFE_DOCUMENT_OPTIONS = {
    isEvalSupported: false,
    enableXfa: false,
    disableAutoFetch: true,
} as const;
